import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'state' })
export class StatePipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    let result = null;
    switch (obj) {
      case 'ACTIVE':
        result = '활성';
        break;
      case 'INACTIVE':
        result = '비활성';
        break;
    }
    return result;
  }
}
